import { observer } from 'mobx-react';
import { FormTemplate } from '../../../../../../../../../../../../Resource/FormTemplates/Types';
import Modal from '../../../../../../../../../../../Modal';
import InviteParticipantStore from '../../Store';
import Body from './Body';
import Header from './Header';

export interface Props {
  store: InviteParticipantStore;
  template: FormTemplate;
  timeZone: string;
  skipCommunications: boolean;
}

export const resetModal = (store: InviteParticipantStore) => {
  store.modalStore.close();
  store.getLicenseInformation();
};

function InviteModal({ timeZone, skipCommunications, store, template }: Props) {
  switch (store.modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={() => resetModal(store)}
          title={<Header />}
          customBackgroundCssClasses="bg-teal-100 opacity-60"
          modalWidth="w-2/5"
        >
          <Body
            submit={store.submit}
            timeZone={timeZone}
            template={template}
            setTimezone={store.setTimezone}
            back={store.back}
            skipCommunications={skipCommunications}
            setSkipCommunications={store.setSkipCommunications}
          />
        </Modal>
      );
  }
}

export default observer(InviteModal);
